import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Cancel from 'material-ui-icons/Cancel';
import CancelDocumentDialog from './CancelDocumentDialog';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
    fontSize: 1.2 + 'rem'
  },
  inlineBlock: {
    display: 'inline-block',
    margin: theme.spacing.unit
  }
});

class CancelButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.openCancelDialog = this.openCancelDialog.bind(this);
    this.handleCloseCancelDialog = this.handleCloseCancelDialog.bind(this);
  }

  openCancelDialog() {
    this.setState({ open: true });
  }

  handleCloseCancelDialog() {
    this.setState({ open: false });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.inlineBlock}>
        <Button
          variant="raised"
          size="small"
          color="secondary"
          onClick={this.openCancelDialog}
        >
          <Cancel className={classes.leftIcon} />
          Cancel
        </Button>
        <CancelDocumentDialog
          document={this.props.document}
          open={this.state.open}
          updateDocuments={this.props.updateDocuments}
          onClose={this.handleCloseCancelDialog}
        />
      </div>
    );
  }
}

CancelButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CancelButton);



// WEBPACK FOOTER //
// ./src/components/CancelButton.js